import axios from 'axios';
import { IInstitution } from '../utils/interfaces/interfaces';
import { institutionAPI } from './routes';

const getInstitutions = async () =>
  await axios.get(institutionAPI.GET_ALL_BASIC);

const getInstitutionByCUI = async (cui: string) =>
  await axios.get(institutionAPI.BY_CUI(cui));

const getInstitution = (id: number) => axios.get(institutionAPI.BY_ID(id));

const updateInstitution = async (id: number, institution: IInstitution) =>
  await axios.put(institutionAPI.MODIFY, {
    id: id,
    name: institution.name,
    cui: institution.cui,
    orderingInstitutionId: institution.orderingInstitutionId,
    address: institution.address
  });

const getOrderingRequests = (id: number) =>
  axios.get(institutionAPI.GET_REQUESTS(id));

const rejectRequest = async (id: number) =>
  await axios.post(institutionAPI.REJECT_REQ(id));
const acceptRequest = async (id: number) =>
  await axios.post(institutionAPI.ACCEPT_REQ(id));

export {
  getInstitution,
  updateInstitution,
  getInstitutions,
  getInstitutionByCUI,
  getOrderingRequests,
  acceptRequest,
  rejectRequest
};
